module.exports = __webpack_public_path__ + "img/yinhuan.4c326695.png";